export default function Django_Delete_Data() {
  return <div>Django_Delete_Data Component</div>;
}
